export const GET_ALL_TOPIC_TYPE = 'GET_ALL_TOPIC_TYPE';
export const GET_ALL_TOPIC_TYPE_SUCCESS = 'GET_ALL_TOPIC_TYPE_SUCCESS';
export const GET_ALL_TOPIC_TYPE_ERROR = 'GET_ALL_TOPIC_TYPE_ERROR';
